import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/model-management/runs/')({
  validateSearch: zodValidator(withDefaults(schema.MODEL_MANAGEMENT, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.MODEL_MANAGEMENT });
    context.validatePermissions({ isAllowed, preload });
  },
});
